import { Box, Typography } from "@mui/material";
import { ResolvedColors } from "../colorResolver";

interface IBandPreviewProps {
  colors: ResolvedColors;
  images: { placeholder?: string };
  likedStarColor: string;
}

export const BandPreview = ({ colors, images, likedStarColor }: IBandPreviewProps) => {
  return (
    <Box sx={{ width: "100%", height: "100%", backgroundColor: colors.primaryColor, overflow: "hidden" }}>
      {/* Native stack header - back button only, always primaryColorDarker */}
      <Box sx={{ backgroundColor: colors.primaryColorDarker, px: 1.5, py: 1 }}>
        <Typography sx={{ color: colors.headerButtonColor, fontSize: 18 }}>‹</Typography>
      </Box>

      <Box
        sx={{
          height: 170,
          backgroundColor: colors.primaryColorDarker,
          backgroundImage: images.placeholder ? `url(${images.placeholder})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <Box
        sx={{
          backgroundColor: colors.artistDetailsBackgroundColor,
          borderTop: `2px solid ${colors.countdownTopBorderColor}`,
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography sx={{ color: colors.primaryColorText, fontWeight: 800, fontSize: 22 }}>
            Marmozets
          </Typography>
          <Typography sx={{ color: colors.primaryColorText, fontSize: 13, display: "block" }}>
            Main
          </Typography>
          <Typography sx={{ color: colors.primaryColorText, fontSize: 13 }}>
            Saturday 17:40 - 18:30
          </Typography>
        </Box>
        <Typography sx={{ color: likedStarColor, fontSize: 26, lineHeight: 1.4 }}>★</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          py: 1.5,
          backgroundColor: colors.socialsBackgroundColor,
          borderBottom: `2px solid ${colors.socialsBottomBorderColor}`,
        }}
      >
        {["TT", "SP", "YT", "FB", "IG"].map((label) => (
          <Box
            key={label}
            sx={{
              width: 26,
              height: 26,
              borderRadius: "50%",
              border: `1.5px solid ${colors.primaryColorText}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="caption" sx={{ color: colors.primaryColorText, fontSize: 8 }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ px: 2, py: 2 }}>
        {[100, 85, 60].map((width, i) => (
          <Box
            key={i}
            sx={{
              height: 8,
              width: `${width}%`,
              borderRadius: 1,
              backgroundColor: colors.primaryColorText,
              opacity: 0.4,
              mb: 1,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
